import { Place } from '../../lib/types/models/place/place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPlaces(search?: string) {
  return restApiClient
    .url(
      encodeNestedObject<{ search?: string }>(constructApiUrl(API.places.getPlaces.url, null), {
        search
      })
    )
    .get<Place[]>()
}
